const SEARCH_HISTORY_QUERY_KEYS = "search-history";

export const searchHistoryQueryKeys = {
  all: [SEARCH_HISTORY_QUERY_KEYS] as const,
  recents: function recents() {
    return [SEARCH_HISTORY_QUERY_KEYS, "recents"] as const;
  },
};
